/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerCreateDto } from '../../models/partner-create-dto';
import { PartnerDto } from '../../models/partner-dto';

export interface PartnerAdminControllerCreateV1$Params {
      body: PartnerCreateDto
}

export function partnerAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: PartnerAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerDto>> {
  const rb = new RequestBuilder(rootUrl, partnerAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerDto>;
    })
  );
}

partnerAdminControllerCreateV1.PATH = '/api/v1/partners/admin';
